module.exports = __webpack_public_path__ + "media/customizations/sunterra/back-0d2ece9e124f57dd49b9db09e43d8068.jpg";